<template>
  <ul class="product-reason">
    <li
      v-for="(reasons, i) in getRejectReasonDetails"
      :key="i"
    >
      <div
        v-if="reasons.rejectReason"
      >
        <div class="reject-reason">
          <span class="icon-exclamation-circle" />
          {{ reasons.rejectReason }}
        </div>
        <span v-html="format(reasons.rejectReasonDetail)" />
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'RejectReasonDetail',
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    getRejectReasonDetails () {
      return this.product.rejectReasonDetails.map(reason => ({
        ...reason,
        rejectReasonDetail: String(reason.rejectReasonDetail) === '' ? reason.rejectReason : reason.rejectReasonDetail,
      }));
    },
  },
  methods: {
    format (rejectReason) {
      return rejectReason.replace('tıklayınız.',
        '<a href=https://tymp.mncdn.com/prod/documents/engagement/yasal_surecler/satisa_uygun_olmayan_urunler.pdf target=_blank>tıklayınız.</a>').replace('tıklayın.',
        '<a href=https://tymp.mncdn.com/prod/documents/engagement/yasal_surecler/satisa_uygun_olmayan_urunler.pdf target=_blank>tıklayınız.</a>');
    },
  },
};
</script>
<style lang="scss" scoped>

.reject-reason {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    word-break: break-all;
    text-overflow: ellipsis;
  }
::v-deep .g-tooltip {
  .text {
    color: white;

    &.-left{
      text-align: right !important;
    }
    &.-right{
      text-align: left !important;
    }
    a {
      color: white;
      text-decoration: underline;
    }
  }

}
</style>
